import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestChecklistGet = {
    path: "/checklist",
    method: RouteHttpVerb.GET
};
export { locationRestChecklistGet };
